'use client'

import RouteErrorBoundary from '@/components/common/RouteErrorBoundary'

export default function Error({
  error,
  reset
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <RouteErrorBoundary
      error={error}
      reset={reset}
      title="Error loading Variable Rate Markets page data"
      description="Something went wrong while loading Variable Rate Markets page data. Please try again."
      homeRoute="/"
      route="/variable"
    />
  )
}
